import { Component, OnInit, Input } from '@angular/core';
import { StringLiteralLike } from 'typescript';
import { QuoteRequestState } from '../../models/quote-request-state';

@Component({
  selector: 'app-company-quoteid-header',
  templateUrl: './company-quoteid-header.component.html',
  styleUrls: ['./company-quoteid-header.component.scss'],
})
export class CompanyQuoteidHeaderComponent implements OnInit {
  @Input() quote: QuoteRequestState;
  @Input() organisationName : string;

  public get orgName() {
    if (this.quote) { 
      let name = (this.quote.organisationName?.length == 0 || this.quote.organisationName?.length == 1) ? this.organisationName : this.quote.organisationName; 
      return this.quote.quoteRequestId ? `${name} (QUOTE ID ${this.quote.quoteRequestId})` : 'New Quote';
    }
    return null;
  }

  ngOnInit(): void {}
}
